import styled from "styled-components";

export const TituloBlocoParte = styled.h1`
    font-size: 13px;
    color: ${({ theme }) => theme.colors.c000000};
    font-weight: 500;
    margin-bottom: 16px;
    display: flex;
    flex-direction: row;
    opacity: 0.6;
    align-items: center;
    text-transform: uppercase;
    gap: 5px;
`;


